import axios from 'axios'

import type { Response as UsersMetadataResponse } from '@src/pages/api/users/[email]/metadata'

export interface Endpoint<Path extends string, Params, Body> {
  endpoint: Path
  params?: Params
  body?: Body
}

export type GetEndpoint<
  Path extends string,
  Params extends { [key: string]: string },
> = Endpoint<Path, Params, void>

export type GetEndpointRequest = GetEndpoint<
  '/users/[email]/metadata',
  { email: string }
>

export interface EndpointResponse {
  '/users/[email]/metadata': UsersMetadataResponse
}

export default class Client {
  async get<Req extends GetEndpointRequest>(
    endpoint: Req,
  ): Promise<EndpointResponse[Req['endpoint']]> {
    const url = this.getURL(endpoint)
    const headers = {
      Accept: 'application/json',
    }

    const response = await axios.get(url, { headers })

    return response.data as EndpointResponse[Req['endpoint']]
  }

  protected getURL<
    Req extends Endpoint<string, { [key: string]: string } | void, unknown>,
  >(endpoint: Req): string {
    const { endpoint: path, params } = endpoint
    const populatedPath = params
      ? path.replace(
          /\[([^\]]+)\]/g,
          (_, key: keyof typeof params) => params[key],
        )
      : path

    return `/api${populatedPath}`
  }
}
